import {useAuthorize} from '@/hooks/useAuth';
import {useEntitledForClient} from '@/hooks/useEntitlements';

export const useCanViewWorkSchedule = () => {
  const canViewWorkSchedule = useAuthorize('VIEW_WORK_SCHEDULE');
  const isWorkScheduleEntitled = useEntitledForClient('WORK_SCHEDULE');

  return canViewWorkSchedule && isWorkScheduleEntitled;
};
